<template>
  <div class="basics-wrapper row py-xxl gap-lgp">
    <homepage-image
      width="100%"
      class="offset-1 offset-lg-2 col-10 col-md-5 col-lg-4"
      height="auto"
      alt="Photo grid of Armoire member Kim wearing various Armoire garments outdoors, at dinner, and at her desk"
      webp-source="howitworks/jan2022/thebasics@2x.webp"
      source="howitworks/jan2022/thebasics.jpg"
      source-type="image/jpeg"/>
    <div class="content offset-1 col-10 col-md-5 d-flex flex-column justify-content-center gap-lg mx-auto mx-md-0">
      <h2 class="mb-md">
        The Basics
      </h2>
      <div
        v-for="(benefit, idx) in bullets"
        :key="`benefit-${idx}`"
        class="d-flex">
        <div>
          <svg-check
            class="benefit-check me-md"
            variant="secondary"/>
        </div>
        <h4 class="text-capitalize">
          {{ benefit }}
        </h4>
      </div>
      <GetStartedButton
        class="mt-lgp mt-lg-xxl mx-auto mx-md-0 fixed-width"
        location="The Basics"/>
    </div>
  </div>
</template>

<script setup>
import HomepageImage from '@/homepage/components/HomepageImage.vue'
import SvgCheck from '@/homepage/components/svg/SvgCheck.vue'
import GetStartedButton from '@/homepage/components/GetStartedButton.vue'

const bullets = [
  'Access to 75K+ high-end styles',
  'Members-only discounts to purchase items you love',
  'Free & fast shipping',
  'Full-service styling',
  'Cleaning is on us'
]
</script>
<style lang="scss" scoped>
.basics-wrapper {
  max-width: 1440px;
  margin: 0 auto;
}
.content {
  @include media-tablet-or-larger {
    max-width: 400px;
  }
}
</style>